import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import classnames from 'classnames';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SnackbarContent from '@mui/material/SnackbarContent';

import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';

import styles from './styles';

const variantIcons = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon
};

class AlertPanel extends React.Component {
    render() {
        const { classes, className, message, variant, ...other } = this.props;

        const Icon = variantIcons[variant];

        return (
            <SnackbarContent
                elevation={0}
                className={classnames(classes.root, classes[variant], className)}
                {...other}
                message={
                    <span id="alert-panel" className={classes.message}>
                        <Icon className={classnames(classes.icon, classes.iconVariant)} />
                        {message}
                    </span>
                }
            />
        );
    }
}

AlertPanel.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['success', 'warning', 'error', 'info'])
};

export default withStyles(AlertPanel,styles);